import { IMatrix4, IVector3 } from '../../../../api.js';
import { GIZMO_AXIS_COLOR, GIZMO_COLOR_FACTOR } from '../GizmoColors.js';
import { MeshDescriptions } from '../MeshDescriptions.js';
export class ScaleArrow {
    constructor(viewer, transform_handling, use_global_transorm, axis) {
        this.transform_handling = transform_handling;
        this.use_global_transorm = use_global_transorm;
        this.axis = axis;
        this._viewer = viewer;
        const color = GIZMO_AXIS_COLOR[axis];
        const arrow_mesh_description = MeshDescriptions.create_scale_arrow(0.5, // shaft length
        0.015, // shaft radius
        0.15, // cube size size
        color, color);
        this._ui_mesh = this._viewer.create_ui_mesh();
        this._ui_mesh.load_mesh(arrow_mesh_description);
        this.gizmo = this._ui_mesh.create_gizmo();
        this.gizmo.color_factor = GIZMO_COLOR_FACTOR.not_active;
        if (axis === 'x') {
            this.gizmo.rotation.z = -90 * (Math.PI / 180);
        }
        else if (axis === 'z') {
            this.gizmo.rotation.x = 90 * (Math.PI / 180);
        }
        this.gizmo.position[this.axis] += 0.25 + 0.05;
        this.add_event_listeners();
        this._ui_mesh.draw_on_top = true;
    }
    add_event_listeners() {
        this.gizmo.pointer_enter_observable.add(this.on_pointer_over.bind(this));
        this.gizmo.drag_begin_observable.add(this.on_drag_start.bind(this));
        this.gizmo.drag_observable.add(this.on_drag.bind(this));
        this.gizmo.pointer_leave_observable.add(this.on_pointer_leave.bind(this));
    }
    on_pointer_over() {
        this.gizmo.color_factor = GIZMO_COLOR_FACTOR.active;
    }
    on_drag_start() {
        this._initial_transform = this.transform_handling.get_world_transform();
    }
    on_drag(_, event) {
        if (!this._initial_transform)
            return;
        if (!this.use_global_transorm) {
            const scale = this.transform_handling.scale.get();
            scale[this.axis] += event.local_delta[this.axis];
            this.transform_handling.scale.set(scale);
            return;
        }
        const current_scale = this.transform_handling.scale.get();
        const current_transform = this._initial_transform;
        const rotation_matrix = IMatrix4.extractRotationMatrix(current_transform);
        const inverse_rotation_matrix = IMatrix4.inverse(rotation_matrix);
        let scale_matrix;
        switch (this.axis) {
            case 'x':
                scale_matrix = IMatrix4.Scale(1 + event.world_delta.x, 1, 1);
                break;
            case 'y':
                scale_matrix = IMatrix4.Scale(1, 1 + event.world_delta.y, 1);
                break;
            case 'z':
                scale_matrix = IMatrix4.Scale(1, 1, 1 + event.world_delta.z);
                break;
        }
        // Transform the scale matrix to object's local space
        let local_scale_matrix = IMatrix4.multiply(inverse_rotation_matrix, scale_matrix);
        local_scale_matrix = IMatrix4.multiply(local_scale_matrix, rotation_matrix);
        const scale_factors = IMatrix4.getScaleValues(local_scale_matrix);
        const new_scale = new IVector3(current_scale.x * scale_factors.x, current_scale.y * scale_factors.y, current_scale.z * scale_factors.z);
        this.transform_handling.scale.set(new_scale);
    }
    on_pointer_leave() {
        this.gizmo.color_factor = GIZMO_COLOR_FACTOR.not_active;
    }
}
//# sourceMappingURL=ScaleArrow.js.map